"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeToStream = exports.streamToBlob = exports.streamToArrayBuffer = exports.streamToText = exports.createWriteStream = exports.createReadStream = exports.getPluginContext = exports.showSaveDialog = exports.showOpenDialog = exports.stat = exports.rm = exports.rename = exports.mkdir = exports.readdirWithFileTypes = exports.readdir = exports.copyFile = exports.appendFile = exports.writeFile = exports.readFile = void 0;
const readFile = (...args) => window.todesktop.fs.readFile(...args);
exports.readFile = readFile;
const writeFile = (...args) => window.todesktop.fs.writeFile(...args);
exports.writeFile = writeFile;
const appendFile = (...args) => window.todesktop.fs.appendFile(...args);
exports.appendFile = appendFile;
const copyFile = (...args) => window.todesktop.fs.copyFile(...args);
exports.copyFile = copyFile;
const readdir = (...args) => window.todesktop.fs.readdir(...args);
exports.readdir = readdir;
const readdirWithFileTypes = (...args) => window.todesktop.fs.readdirWithFileTypes(...args);
exports.readdirWithFileTypes = readdirWithFileTypes;
const mkdir = (...args) => window.todesktop.fs.mkdir(...args);
exports.mkdir = mkdir;
const rename = (...args) => window.todesktop.fs.rename(...args);
exports.rename = rename;
const rm = (...args) => window.todesktop.fs.rm(...args);
exports.rm = rm;
const stat = (...args) => window.todesktop.fs.stat(...args);
exports.stat = stat;
const showOpenDialog = (...args) => window.todesktop.fs.showOpenDialog(...args);
exports.showOpenDialog = showOpenDialog;
const showSaveDialog = (...args) => window.todesktop.fs.showSaveDialog(...args);
exports.showSaveDialog = showSaveDialog;
const getPluginContext = () => window.todesktop.fs.meta;
exports.getPluginContext = getPluginContext;
/**
 * Creates a readable stream from a file
 * @param dirName Directory name to access (e.g., 'userData', 'documents')
 * @param path Path to the file relative to the directory
 * @param options Stream options
 * @returns A ReadableStream that can be used with fetch API and other Web platform features
 */
const createReadStream = (dirName, path, options) => __awaiter(void 0, void 0, void 0, function* () {
    console.log("Client createReadStream called with:", {
        dirName,
        path,
        options,
    });
    // Ensure path is a string
    if (typeof path !== "string") {
        throw new Error(`Path must be a string, got ${typeof path}`);
    }
    // Get the streaming factory from the preload script
    const streamFactory = (yield window.todesktop.fs.createReadStream(dirName, path, options));
    console.log("Stream factory:", streamFactory);
    // Create a ReadableStream in the renderer context
    return new ReadableStream({
        start(controller) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    // Start the stream and get the streamId
                    const streamId = yield streamFactory.start();
                    console.log("Stream started with ID:", streamId);
                    // Track if stream is closed
                    let isClosed = false;
                    // Setup data event handler
                    const removeDataListener = streamFactory.onData(streamId, (data) => {
                        // Convert base64 string to Uint8Array using browser-compatible approach
                        if (typeof data === "string") {
                            const binaryString = atob(data);
                            const bytes = new Uint8Array(binaryString.length);
                            for (let i = 0; i < binaryString.length; i++) {
                                bytes[i] = binaryString.charCodeAt(i);
                            }
                            controller.enqueue(bytes);
                        }
                        else {
                            controller.enqueue(data);
                        }
                    });
                    // Setup error event handler
                    const removeErrorListener = streamFactory.onError(streamId, (error) => {
                        if (!isClosed) {
                            isClosed = true;
                            controller.error(new Error(error.message || "Stream error"));
                        }
                    });
                    // Setup end event handler
                    const removeEndListener = streamFactory.onEnd(streamId, () => {
                        if (!isClosed) {
                            isClosed = true;
                            controller.close();
                        }
                    });
                    // Setup close event handler
                    const removeCloseListener = streamFactory.onClose(streamId, () => {
                        if (!isClosed) {
                            isClosed = true;
                            controller.close();
                        }
                    });
                    // Store cleanup functions
                    this.cleanup = () => {
                        removeDataListener();
                        removeErrorListener();
                        removeEndListener();
                        removeCloseListener();
                    };
                    // Store streamId for cancellation
                    this.streamId = streamId;
                }
                catch (err) {
                    console.error("Error starting stream:", err);
                    controller.error(err);
                }
            });
        },
        cancel() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.streamId) {
                    yield streamFactory.cancel(this.streamId);
                }
                if (this.cleanup) {
                    this.cleanup();
                }
            });
        },
    });
});
exports.createReadStream = createReadStream;
/**
 * Creates a writable stream to a file
 * @param dirName Directory name to access (e.g., 'userData', 'documents')
 * @param path Path to the file relative to the directory
 * @param options Stream options
 * @returns A WritableStream that can be used with fetch API and other Web platform features
 */
const createWriteStream = (dirName, path, options) => __awaiter(void 0, void 0, void 0, function* () {
    console.log("Client createWriteStream called with:", {
        dirName,
        path,
        options,
    });
    // Ensure path is a string
    if (typeof path !== "string") {
        throw new Error(`Path must be a string, got ${typeof path}`);
    }
    // Get the streaming factory from the preload script
    // Use type assertion to work around the missing interface
    const streamFactory = (yield window.todesktop.fs.createWriteStream(dirName, path, options));
    console.log("Stream factory:", streamFactory);
    // Create a WritableStream in the renderer context
    return new WritableStream({
        start() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    // Start the stream and get the streamId
                    const streamId = yield streamFactory.start();
                    console.log("Write stream started with ID:", streamId);
                    // Store streamId for write operations
                    this.streamId = streamId;
                    // Track if stream is closed
                    this.isClosed = false;
                    // Setup error event handler
                    const removeErrorListener = streamFactory.onError(streamId, (error) => {
                        if (!this.isClosed) {
                            this.isClosed = true;
                            // A controller.error is not available in WritableStream
                            console.error("Write stream error:", error);
                        }
                    });
                    // Setup close event handler
                    const removeCloseListener = streamFactory.onClose(streamId, () => {
                        if (!this.isClosed) {
                            this.isClosed = true;
                        }
                    });
                    // Store cleanup functions
                    this.cleanup = () => {
                        removeErrorListener();
                        removeCloseListener();
                    };
                }
                catch (error) {
                    console.error("Failed to start write stream:", error);
                    throw error;
                }
            });
        },
        write(chunk) {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.isClosed) {
                    throw new Error("Stream is closed");
                }
                try {
                    if (streamFactory.write) {
                        yield streamFactory.write(this.streamId, chunk);
                    }
                    else {
                        throw new Error("Write method not available on stream factory");
                    }
                }
                catch (error) {
                    console.error("Error writing to stream:", error);
                    throw error;
                }
            });
        },
        close() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.isClosed) {
                    this.isClosed = true;
                    try {
                        if (streamFactory.end) {
                            yield streamFactory.end(this.streamId);
                        }
                        else {
                            throw new Error("End method not available on stream factory");
                        }
                        // Run cleanup
                        if (this.cleanup) {
                            this.cleanup();
                        }
                    }
                    catch (error) {
                        console.error("Error closing stream:", error);
                        throw error;
                    }
                }
            });
        },
        abort(reason) {
            console.log("Aborting write stream:", reason);
            if (!this.isClosed) {
                this.isClosed = true;
                // Cancel the stream
                if (this.streamId) {
                    streamFactory.cancel(this.streamId).catch((error) => {
                        console.error("Error cancelling stream:", error);
                    });
                }
                // Run cleanup
                if (this.cleanup) {
                    this.cleanup();
                }
            }
        },
    });
});
exports.createWriteStream = createWriteStream;
/**
 * Helper function to convert a ReadableStream to text
 * @param stream The readable stream to convert
 * @returns A promise that resolves to the stream content as text
 */
const streamToText = (stream) => __awaiter(void 0, void 0, void 0, function* () {
    const reader = stream.getReader();
    const decoder = new TextDecoder("utf-8");
    let result = "";
    try {
        while (true) {
            const { done, value } = yield reader.read();
            if (done)
                break;
            result += decoder.decode(value, { stream: true });
        }
    }
    finally {
        reader.releaseLock();
    }
    return result + decoder.decode(); // Flush the decoder
});
exports.streamToText = streamToText;
/**
 * Helper function to convert a ReadableStream to an ArrayBuffer
 * @param stream The readable stream to convert
 * @returns A promise that resolves to the stream content as an ArrayBuffer
 */
const streamToArrayBuffer = (stream) => __awaiter(void 0, void 0, void 0, function* () {
    const reader = stream.getReader();
    const chunks = [];
    let totalLength = 0;
    try {
        while (true) {
            const { done, value } = yield reader.read();
            if (done)
                break;
            chunks.push(value);
            totalLength += value.length;
        }
    }
    finally {
        reader.releaseLock();
    }
    // Combine chunks into a single ArrayBuffer
    const result = new Uint8Array(totalLength);
    let offset = 0;
    for (const chunk of chunks) {
        result.set(chunk, offset);
        offset += chunk.length;
    }
    return result.buffer;
});
exports.streamToArrayBuffer = streamToArrayBuffer;
/**
 * Helper function to convert a ReadableStream to a Blob
 * @param stream The readable stream to convert
 * @param mimeType Optional MIME type for the resulting blob
 * @returns A promise that resolves to the stream content as a Blob
 */
const streamToBlob = (stream, mimeType) => __awaiter(void 0, void 0, void 0, function* () {
    const response = new Response(stream);
    const blob = yield response.blob();
    // If a mimeType is specified, create a new blob with that type
    if (mimeType) {
        return new Blob([yield blob.arrayBuffer()], { type: mimeType });
    }
    return blob;
});
exports.streamToBlob = streamToBlob;
/**
 * Helper function to write data to a WritableStream and close it
 * @param stream The writable stream
 * @param data The data to write (string, ArrayBuffer, or Uint8Array)
 */
const writeToStream = (stream, data) => __awaiter(void 0, void 0, void 0, function* () {
    const writer = stream.getWriter();
    try {
        let buffer;
        if (typeof data === "string") {
            // Convert string to Uint8Array using TextEncoder
            buffer = new TextEncoder().encode(data);
        }
        else if (data instanceof ArrayBuffer) {
            // Convert ArrayBuffer to Uint8Array
            buffer = new Uint8Array(data);
        }
        else {
            // Already a Uint8Array
            buffer = data;
        }
        yield writer.write(buffer);
    }
    finally {
        yield writer.close();
    }
});
exports.writeToStream = writeToStream;
